<template>
  <div class=" is-fullwidth">
    <div class="level">
        <div class="level-left">
          <div class="columns" >
              <div class="select col">
                <select v-model="area" @change="getData()">
                  <option value="">Select Area</option>
                  <option value="on_floor">On Floor</option>
                  <option value="off_floor">Off Floor</option>
                  <option value="embroidery">Embroidery</option>
                  <option value="silicon_stripes">Silicon Printing</option>
                  
                </select>
              </div>

              <div class="select col">
                <select v-model="user_id" @change="getData()">
                  <option value="">Select User</option>
                  <option  v-for="row in user_list" :key="row.user_id" :value="row.user_id">{{ row.firstname}} {{ row.surname }}</option>
                  
                </select>
              </div>
              

             <div class=" col">
                &nbsp;<input type="date" class="input" v-model="start_date" @change="getData()"/>
                
              </div>
              <div class=" col" >
                &nbsp;<input type="date" class="input" v-model="end_date" @change="getData()"/>
                
              </div>

              <div class="col">
                  <table class="table is-hoverable is-bordered " id="overviewtable" >
                    <tbody>
                      <tr>
                        <td class="">Total {{ total_label }}</td>
                        <td>{{ total_qty }}</td>
                      
                        </tr>
                    </tbody>
                  </table>
                </div>
            </div>
      </div>
        
      </div>
      <div class="notification is-info" v-if="loading == true">Loading data ...</div>

      

    <table class="table is-hoverable is-fullwidth" id="entriestable" v-if="loading == false && filteredEntries.length > 0 ">
    	<thead>
    		<tr>
          <th>Date</th>
          <th v-if="area != 'savings'">Area </th>
          <th>User </th>
        <th v-if="area != 'savings'">Qty</th>
        <th v-if="area != 'savings'">Size</th>
        <th>Order</th>
        <th v-if="area == 'savings'">Status</th>
       
   	 	    </tr>
    	</thead>
    	<tbody>
		    
        <tr v-for="row in filteredEntries" v-bind:key="row.id" >
          <td >{{ row.date }}</td>
          <td v-if="area != 'savings'">{{ row.makeup_area }}</td>
          <td >{{ row.firstname }} {{ row.surname }}</td>
          <td v-if="area != 'savings'">{{row.qty}}</td>
          <td v-if="area != 'savings'">{{row.size_name}}</td>
          <td>{{row.ponumber}}</td>
          <td v-if="area == 'savings'">{{ showSaveStatus(row.status) }}</td>
              
			</tr>
    	</tbody>
    </table>
    


    <button @click="exportXLS()" class="button is-info" v-if="loading==false">Export to Excel</button>

     
    
  </div>
</template>

<script>

import OrderService from '@/services/OrderService.js';
import OrderMixin from "@/mixins/OrderMixin.js";
import XLSX from 'xlsx';

export default {
  name:'OffshoreSummaryReport',
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
     entries: [],
     area: '',
      start_date: '',
        end_date: '',
      currentSort: 'count',
      currentSortDir: 'desc',
      loading: true,
     accessToken: '',
     user_id: '',
     machine_id: '',
     combinedData: [],
     grandTotal : []
     
     
    }
  },
  created() {
      this.getAccessToken()
        .then(() => { 
            this.getData()
        });
      
    },
  methods: {
    
    exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('entriestable'), {sheet:"Sheet 1"});
		 XLSX.writeFile(wb, 'Offshore Summary Report.xlsx')

	 },
   
    async getData() {
      this.loading=true;
      

      
        OrderService.getOffshoreReportData(this.accessToken, this.area, this.start_date, this.end_date)
            .then(
              (entries => {
                
                this.$set(this, "entries", entries);
                this.loading=false;

                this.processData(entries);
              }).bind(this)
            );
        
      
    },
   
    getStartDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() - 7);
            return d.toISOString().slice(0,10);
             
        },

        combineObjects(data) {
          const combinedData = {};
          
          data.forEach(item => {
            if (combinedData[item.ponumber]) {
              combinedData[item.ponumber].qty += item.qty;
            } else {
              combinedData[item.ponumber] = { ...item };
            }
          });
          
          return Object.values(combinedData);
        },
        
        calculateGrandTotal(data) {
          let grandTotal = 0;
          
          data.forEach(item => {
            grandTotal += item.qty;
          });
          
          return grandTotal;
        },
        
        processData(data) {
          const combinedData = this.combineObjects(data);
          const grandTotal = this.calculateGrandTotal(combinedData);
          
          console.log("Combined Data:", combinedData);
          console.log("Grand Total:", grandTotal);
          
          // You can return the combined data and grand total if needed
          //return { combinedData, grandTotal };

          this.combinedData = combinedData
          this.grandTotal = grandTotal
        } 
   
  },
  computed : {
     
    
      total_qty: function() {
        if(this.area == 'savings')
        {
          return this.filteredEntries.length;
        }
        else{
          return this.filteredEntries.reduce((total, item) => total + item.qty, 0);
        }
        
      },
      
      total_label: function() {
          if(this.area == "savings")
          {
            return "Orders"
          }
          else{
            return "Garments"
          }
        },

        user_list: function() {
          let user_list = []
          let user_id_list = []
          
          this.entries.forEach(element => {
             
             if(!user_id_list.includes(element.user_id))
             {
              var this_user = {user_id: element.user_id, firstname: element.firstname, surname: element.surname}
              user_list.push(this_user)

              user_id_list.push(element.user_id)
             }
            
          })

          user_list.sort()

          return user_list
        },
        machine_list: function() {
          let machine_list = []
          let machine_id_list = []
          
          this.entries.forEach(element => {
             
             if(!machine_id_list.includes(element.machine_id))
             {
              var this_machine = {machine_id: element.machine_id, machine_name: element.machine_name}
              machine_list.push(this_machine)

              machine_id_list.push(element.machine_id)
             }
            
          })

          machine_list.sort()
          

          return machine_list
        },
        filteredEntries: function () {
          let filteredEntries = []

          if(this.user_id != "")
          {
            filteredEntries = this.entries.filter(row => row.user_id == this.user_id)

            if(this.machine_id != "")
            {
              filteredEntries = filteredEntries.filter(row => row.machine_id == this.machine_id)
            }
          }
          else{

            if(this.machine_id != "")
            {
              filteredEntries = this.entries.filter(row => row.machine_id == this.machine_id)
            }
            else{
              filteredEntries = this.entries
            }

            
          }

            return filteredEntries
        
      },

  },

 
  mounted() {
    if (localStorage.offshoresummary_start_date) {
      this.start_date = localStorage.offshoresummary_start_date;
    }
    else{
      this.start_date = this.getStartDate()
    }

    if (localStorage.offshoresummary_end_date) {
      this.end_date = localStorage.offshoresummary_end_date;
    }
    else{
      this.end_date = new Date().toISOString().slice(0,10)
    }

    if (localStorage.offshoresummary_area) {
      this.area = localStorage.offshoresummary_area;
    }
    else{
      this.area = ''
    }

    if (localStorage.offshoresummary_user_id) {
      this.user_id = localStorage.offshoresummary_user_id;
    }
    else{
      this.user_id = ''
    }

    
    
  },
  watch: {
    area: function () {
      localStorage.offshoresummary_area = this.area;
      //this.entries = []
      //this.getData()
    },
    start_date: function () {
      localStorage.offshoresummary_start_date = this.start_date;
      //this.entries = []
      //this.getData()
    },
    end_date: function () {
      localStorage.offshoresummary_end_date = this.end_date;
      //this.entries = []
      //this.getData()
    },
    user_id: function () {
      localStorage.offshoresummary_user_id = this.user_id;
      
    },
    
  }
}



</script>


